import { render, staticRenderFns } from "./ConfirmationPackage.vue?vue&type=template&id=d2fb01a6&scoped=true&"
import script from "./ConfirmationPackage.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPackage.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationPackage.vue?vue&type=style&index=0&id=d2fb01a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fb01a6",
  null
  
)

export default component.exports